export const AccountHelper = {
    Level:{
        User: 0,
        BoatMan: 1,
        USER: 2,
        Administrato: 10
    },

    LevelList: [
        { value: 0, name: "Usuário" },
        { value: 1, name: "Barqueiro" },
        { value: 2, name: "Usuário" },
        { value: 10, name: "Administrador" }
    ],

    TranslateLevel: (level) => {
        switch (level) {
            case 0: return "Usuário";
            case 1: return "Barqueiro";
            case 2: return "Usuário";
            case 10: return "Administrador";
            default: return "Desconhecido";
        }
    },
};